<template>
<div>

  <section class="content">

      <!-- Default box -->
      <div class="box">
        <div class="box-header with-border">
          <h3 class="box-title">Update Group Leader List</h3>
           
          <div class="box-tools pull-right">
            <button type="button" class="btn btn-box-tool" data-widget="collapse" data-toggle="tooltip" title="" data-original-title="Collapse">
              <i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove" data-toggle="tooltip" title="" data-original-title="Remove">
              <i class="fa fa-times"></i></button>
          </div>
        </div>
        <div class="box-body">
          
         
         <div class="row">
        <div class="col-md-12">
          <!-- general form elements disabled -->
          <div class="card card-warning">
            <!-- /.card-header -->
            <div class="card-body">
              <form role="form" @submit.prevent="updateCenterLeader">
                <div class="row">
                  <div class="col-sm-3">
                    <!-- text input -->

                    <div class="form-group">
                      <label>Select Branch <span class="red">*</span></label>
                      <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getBranch"></v-select>
                      
                      <has-error
                        :form="form"
                        field="branch_id"
                      ></has-error>
                    </div>

                    <div class="form-group">
                      <button v-if="canAccess('update-center-leader-create')" type="submit" class="btn btn-success">
                        <i class="fa fa-eye"></i> SAVE RECORDS
                      </button>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Group <span class="red">*</span></label>
                      <v-select v-model="collection_center" name="collection_center_id" label="name" :options="collection_centers" placeholder="Select Group" v-on:input="getCenter"></v-select>
                      
                      <has-error
                        :form="form"
                        field="collection_center_id"
                      ></has-error>
                    </div>
                  </div>

                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Group Leader <span class="red">*</span></label>
                      <v-select v-model="mem"  name="center_leader_id" label="name" :options="members" placeholder="Select Employee" v-on:input="getBranchEmployee">
                        
                      </v-select>
                      
                      <has-error
                        :form="form"
                        field="center_leader_id"
                      ></has-error>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="form-group">
                      <label>Date <span class="red">*</span></label>
                      <input type="date" v-model="form.date"  name="date" class="form-control" placeholder="Select Date">
                      
                      <has-error
                        :form="form"
                        field="date"
                      ></has-error>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">Center Leader Transfer List</h3>
            </div>
            <!-- /.card-header -->
            <div class="card-body table-sm">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                styleClass="vgt-table condensed"
                :pagination-options="{
                  enabled: true,
                  perPage: 10,
                  perPageDropdown: [10, 20, 30],
                }"
                :search-options="{
                  enabled: true,
                  trigger: 'enter',
                }"
              >
                <template slot="table-row"> </template>
              </vue-good-table>
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.card -->
        </div>
        <!-- /.col -->
      </div>
      <!-- /.row -->
         
                
        </div>
        <!-- /.box-body -->
        <div class="box-footer">
          List of all Update Leader Center
        </div>
        <!-- /.box-footer-->
      </div>
      <!-- /.box -->

  </section>
</div>
</template>

<script>
export default {
  name: 'UpdateCenterLeader',
  data () {
    return {
      branches: [],
      collection_centers: [],
      collection_center: {},
      members: [],
      mem: {},
      form: new Form({
        id: '',
        collection_center_id: '',
        branch_id: '',
        center_leader_id: '',
        date: '',
        status: false
      }),
      columns: [
        {
          label: 'GROUP LEADER',
          field: 'center_leader.name'
        },
        {
          label: 'BRANCH',
          field: 'branch.name'
        },
        {
          label: 'GROUP',
          field: 'collection_center.name'
        },

        {
          label: 'DATE',
          field: 'date'
        }
      ],
      rows: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    updateCenterLeader () {
      if (
        this.form.branch_id !== '' &&
        this.form.collection_center_id !== '' &&
        this.form.center_leader_id !== '' &&
        this.form.date !== ''
      ) {
        this.$axios
        .post('updatecenterleader', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then(() => {
          Fire.$emit('AfterCreate')
          Toast.fire({
            icon: 'success',
            title: 'Group Leader Updated Successfully'
          })
        })
      } else {
        if (this.form.date === '') {
          this.form.errors.errors = {date: ['The Date field is required']}
        }
        if (this.form.center_leader_id === '') {
          this.form.errors.errors = {center_leader_id: ['The Group Leader field is required.']}
        }
        if (this.form.collection_center_id === '') {
          this.form.errors.errors = { collection_center_id: ['The group field is required.'] }
        }
        if (this.form.branch_id === '') {
          this.form.errors.errors = {branch_id: ['The branch field is required.']}
        }
      }
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getBranch () {
      this.member = {}
      this.collection_center = {}
      this.form.branch_id = this.branch.id
      this.form.collection_center_id = ''
      this.form.center_leader_id = ''
      this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.collection_centers = data.data
      })
    },
    getCenter () {
      this.member = {}
      this.form.center_leader_id = ''
      this.form.collection_center_id = this.collection_center.id
      this.$axios.get('collectioncentermember?all=all&collection_center_id=' + this.collection_center.id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
      .then((response) => response.data)
      .then((data) => {
        this.members = data.data
        _.forEach(this.members, function (item, key) {
          this.members[key].name = item.member.name + ' (' + item.member.code + ')'
        }.bind(this))
      })
    },
    getBranchEmployee () {
      this.form.center_leader_id = this.mem.member.id
    },
    loadData () {
      this.$axios
        .get('updatecenterleader', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          // console.log(data.data)
          this.rows = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.loadData()
    this.loadBranch()
    Fire.$on('AfterCreate', () => {
      this.loadData()
    })
  }
}
</script>
<style scoped>
.invalid-feedback {
  color: red
}
</style>



// WEBPACK FOOTER //
// UpdateCenterLeader.vue?8e120e02